import "./accident-step-circumstances.scss";
import { Image } from "react-bootstrap";
import { useDataEntryAccidentStepCircumstances } from "./accident-step-circumstances.hook";
import { DataEntryAccidentStepSectionProps, typedMemo } from "src/types";

export const DataEntryAccidentStepCircumstances = typedMemo(
  (props: DataEntryAccidentStepSectionProps) => {
    const { formikAccidentValues } = props;

    const {
      imagesSource,
      accidentCircumstancesOptions,
      vehicleAIndex,
      vehicleBIndex,
      vehicleAError,
      vehicleBError,
      handleCircumstanceChange,
      t,
    } = useDataEntryAccidentStepCircumstances(props);

    return (
      <div className="circ-container">
        {/* Header */}
        <div className="circ-header">
          <div className="circ-header-cell circ-header-title">
            {t("commons.plate_a")}
          </div>
          <div className="circ-header-cell"></div>
          <div className="circ-header-cell circ-header-title">
            {t("commons.plate_b")}
          </div>
          <div className="circ-header-cell"></div>
        </div>

        {/* Body */}
        {accidentCircumstancesOptions.map((row, index) => {
          const selectedA =
            formikAccidentValues.vehicleAccidentCircumstances[vehicleAIndex]
              ?.selectedCircumstance === row.id;

          const selectedB =
            formikAccidentValues.vehicleAccidentCircumstances[vehicleBIndex]
              ?.selectedCircumstance === row.id;

          return (
            <div key={row.id} className="circ-row">
              {/* Veicolo A */}
              <div
                className="circ-cell circ-checkbox"
                onClick={() => handleCircumstanceChange(0, row.id)}
                style={{ cursor: "pointer" }}
              >
                <input
                  type="radio"
                  value={row.id}
                  checked={selectedA}
                  name={`accidentData.vehicleAccidentCircumstances.${vehicleAIndex}.selectedCircumstance`}
                  hidden
                  readOnly
                />
                <Image
                  src={imagesSource[`${selectedA ? "full" : "empty"}-enabled`]}
                  width={18}
                  height={18}
                />
              </div>

              {/* Numero opzione */}
              <div className="circ-cell circ-number">{index + 1}</div>

              {/* Veicolo B */}
              <div
                className="circ-cell circ-checkbox"
                onClick={() => handleCircumstanceChange(1, row.id)}
                style={{ cursor: "pointer" }}
              >
                <input
                  type="radio"
                  value={row.id}
                  checked={selectedB}
                  name={`accidentData.vehicleAccidentCircumstances.${vehicleBIndex}.selectedCircumstance`}
                  hidden
                  readOnly
                />
                <Image
                  src={imagesSource[`${selectedB ? "full" : "empty"}-enabled`]}
                  width={18}
                  height={18}
                />
              </div>

              {/* Descrizione opzione */}
              <div className="circ-cell circ-label">{row.value}</div>
            </div>
          );
        })}
        {vehicleAError && <div className="circ-error">{`${t("commons.plate_a")}: ${vehicleAError}`}</div>}
        {vehicleBError && <div className="circ-error">{`${t("commons.plate_b")}: ${vehicleBError}`}</div>}
      </div>
    );
  }
);
